import { reactive } from "vue"

export const globalState = reactive({
  systemConfig: {
    dataResourceUpdateInterval:{
      activeDashboardInterval: null,
      dataInterval: null,
      resourceInterval: null
    } ,
    keycloak:{
      clientId: '', 
      realm: '',
      url: ''
    } 
  },
  isLoading: true,
  response: undefined,
})

export const updtInterval = reactive({
  dataInterval: undefined, 
  resourceInterval: undefined,
  activeDashboardInterval: undefined
})
